module.exports = __webpack_public_path__ + "static/zalecenia_montazowe-0dcdb3546eb5ce456d938aa75698efc8.pdf";